import { request } from '@/utils/request';

// 栏目-获取标签列表
export function categoryGetList(params) {
    return request({
      url: '/base/agent/category/getList',
      method: 'get',
      params
    })
  }

// 知识库列表统计
export function statistics(type,code) {
    return request({
      url: `/base/agent/knowledge/statistics/${type}/${code}`,
      method: 'get',
    })
  }

// 知识库列表
export function knowledgeList(params) {
    return request({
      url: '/base/agent/knowledge/list',
      method: 'get',
      params
    })
  }

// 新增-修改技能题收藏-掌握
export function favoriteSave(data) {
    return request({
      url: '/base/agent/knowledge/favorite/save',
      method: 'post',
      data
    })
  }


// 新增-修改学习记录表
export function learnRecordSave(medicalKnowledgeId,practiceTime) {
    return request({
      url: `/base/agent/knowledge/learnRecord/save/${medicalKnowledgeId}/${practiceTime}`,
      method: 'post',
    })
  }

// 小程序配置信息
export function configInfo(params) {
    return request({
      url: '/base/miniApp/config/info',
      method: 'get',
      params
    })
  }